import { TypographyStylesProvider, Image } from "@mantine/core";
import React from "react";
import { IconWriting } from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const SIGN_MESSAGE_CONTENT = (
  <TypographyStylesProvider>
    <p>This button allows you to "sign" a message with your Lightning node.</p>
    <DocsButton
      ariaLabel="Sign Message button"
      text="Sign Message"
      leftSection={<IconWriting />}
      disabled={false}
    />
    <p>
      Typically a website or app will want you to prove that you are
      owner/runner of your node.
    </p>

    <p>
      They will provide to you some arbitrary code, and you'll put that here....
    </p>
    <SimpleImage h={200} src="docs_images/sign_message_with_node.png" />
    <p>
      ...and your node will produce a response that proves you are the owner of
      the node.
    </p>

    <p>
      {" "}
      This is made possible by the magic of public/private key cryptography.
      Your node has a private key that it never shares with anyone, and a public
      key that it shares with the world. When you sign a message, you are using
      your private key to produce a signature that can be verified by anyone who
      has your public key.
    </p>
  </TypographyStylesProvider>
);
